var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 10.414 10.414"}},[_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round"}},[_c('path',{attrs:{"d":"M.707.707l9 9M9.707.707l-9 9"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }